@import './pk-list-stat-item.variables';

:host {
  @apply block;

  font-family: var(--list-stat-item--font);
}

.data-container {
  @apply mb-s flex items-center justify-between;
}

:host(.comparison) .data-container {
  @apply items-baseline;
}

:host(.circular-comparison) .data-container {
  @apply mb-0;
}

.label {
  @apply overflow-hidden text-ellipsis whitespace-nowrap pr-xs2 text-s leading-m text-[color:--list-stat-item--label-color];
}

:host(.comparison),
:host(.circular-comparison) {
  .label {
    @apply px-xs2 py-0;
  }
}

.data {
  @apply font-semibold text-l leading-m text-[color:--list-stat-item--data-color];
}

pk-divider {
  @apply block;
}
